"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLibrary = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("Common/AssetLibrary/Types");
var AssetLibrarySidebar_1 = require("Common/AssetLibrary/AssetLibrarySidebar/AssetLibrarySidebar");
var ImageTopActionBar_1 = require("Common/AssetLibrary/ImageLibrary/Components/ImageTopActionBar/ImageTopActionBar");
var ImageLibraryUtils_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryUtils");
var Types_2 = require("Common/AssetLibrary/ImageLibrary/Types");
var ImageAssetPanel_1 = require("Common/AssetLibrary/ImageLibrary/Components/ImageAssetPanel/ImageAssetPanel");
var ImageCard_1 = require("Common/AssetLibrary/ImageLibrary/Components/ImageCard/ImageCard");
var UnsplashCollection_1 = require("Common/AssetLibrary/ImageLibrary/Components/UnsplashCollection/UnsplashCollection");
var Types_3 = require("@CommonFrontendBackend/AssetLibrary/Types");
var ImageFetchingErrorMessageUtils_1 = require("./Components/ImageFetchingErrorMessage/ImageFetchingErrorMessageUtils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StringManipulater_1 = require("Utils/StringManipulater");
var MultiSelectStore_1 = __importDefault(require("Common/MultiSelectStore/MultiSelectStore"));
var DuplicateUploadNotifier_1 = require("Common/Upload/DuplicateUploadNotifier");
var DashboardTypes_1 = require("Dashboard/DashboardTypes");
var SetDragImage_1 = require("Dashboard/SetDragImage");
var DragLabel_1 = __importDefault(require("Dashboard/DragLabel/DragLabel"));
var ImageActionTray_1 = require("./Components/ImageActionTray/ImageActionTray");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ImageLibrary = (function (_super) {
    __extends(ImageLibrary, _super);
    function ImageLibrary(props) {
        var _this = _super.call(this, props) || this;
        _this.areImagesBeingDragged = false;
        _this.multiSelectStore = new MultiSelectStore_1.default();
        _this.onUploadImage = function (file) { return __awaiter(_this, void 0, Promise, function () {
            var _a, uploadStore, launchOptions, useAssetCallback, uploadFolderId, uploadId, url;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, uploadStore = _a.uploadStore, launchOptions = _a.launchOptions, useAssetCallback = _a.useAssetCallback;
                        uploadFolderId = (0, ImageLibraryUtils_1.toApiFolderId)(this.selectedFolder);
                        uploadId = uploadStore.upload(file, { folderId: uploadFolderId });
                        this.duplicateUploadNotifier.notifyOnDuplicateUpload(uploadId);
                        if (!launchOptions.earlyExit) return [3, 1];
                        useAssetCallback(Types_3.MediaSource.FastUpload, { uploadId: uploadId }, Types_3.MetricSource.UploadGallery);
                        return [3, 3];
                    case 1: return [4, uploadStore.waitForUpload(uploadId)];
                    case 2:
                        url = (_b.sent()).url;
                        useAssetCallback(Types_3.MediaSource.FastUpload, { url: url }, Types_3.MetricSource.UploadGallery);
                        _b.label = 3;
                    case 3: return [2];
                }
            });
        }); };
        _this.onDropOnFolder = function (event, folderId) { return __awaiter(_this, void 0, void 0, function () {
            var foldersViewStore, dragData, rawDragData, folderToMove;
            return __generator(this, function (_a) {
                foldersViewStore = this.props.foldersViewStore;
                rawDragData = event.dataTransfer.getData("application/json");
                try {
                    dragData = JSON.parse(rawDragData);
                }
                catch (e) {
                }
                if (!!dragData) {
                    if (dragData.type === DashboardTypes_1.DragDataType.SidebarFolder) {
                        folderToMove = dragData.folderToMove;
                        if (folderId === Types_2.ImageLibrarySystemFolder.Uploads) {
                            foldersViewStore.moveFolder(folderToMove, null);
                        }
                        else {
                            foldersViewStore.moveFolder(folderToMove, folderId);
                        }
                    }
                    else if (dragData.type === DashboardTypes_1.DragDataType.ResourceCards) {
                        this.handleOnMoveImages(folderId);
                    }
                }
                return [2];
            });
        }); };
        _this.getTopActionBarTitle = function () {
            var _a = _this.props, viewStore = _a.viewStore, foldersViewStore = _a.foldersViewStore;
            var titleIcon = (0, Types_1.FolderIconsMapping)(icons_1.IconSize.Large)[_this.selectedFolder];
            if ((0, ImageLibraryUtils_1.isUnsplashFolder)(_this.selectedFolder) && !(0, ImageLibraryUtils_1.isShowingCollections)(viewStore)) {
                if ((0, ImageLibraryUtils_1.isShowingStockImages)(viewStore)) {
                    return {
                        text: "Qwilr Collection",
                        icon: react_1.default.createElement(icons_1.Folder, { size: icons_1.IconSize.Large }),
                    };
                }
                if (_this.props.viewStore.getSearchTerm()) {
                    return {
                        text: "Images with \"".concat(_this.props.viewStore.getSearchTerm(), "\""),
                        icon: titleIcon,
                    };
                }
                if (_this.props.viewStore.selectedCollection) {
                    return {
                        text: (0, lodash_1.capitalize)(_this.props.viewStore.selectedCollection.title) || "",
                        icon: titleIcon,
                    };
                }
            }
            if ((0, ImageLibraryUtils_1.isAnUploadsFolder)(_this.selectedFolder) && _this.props.viewStore.getSearchTerm()) {
                return {
                    text: "Images with \"".concat(_this.props.viewStore.getSearchTerm(), "\""),
                    icon: (0, Types_1.FolderIconsMapping)(icons_1.IconSize.Large)[Types_2.ImageLibrarySystemFolder.Uploads],
                };
            }
            if (Types_1.FolderNamesMapping[_this.selectedFolder] !== undefined) {
                return {
                    text: Types_1.FolderNamesMapping[_this.selectedFolder],
                    icon: titleIcon,
                };
            }
            if (!!foldersViewStore) {
                return {
                    text: foldersViewStore.getFolderName(_this.selectedFolder),
                    icon: react_1.default.createElement(icons_1.Folder, { size: icons_1.IconSize.Large }),
                };
            }
        };
        _this.fetchImages = function () { return __awaiter(_this, void 0, Promise, function () {
            var currentSearchTerm, selectedCollectionId, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, ImageLibraryUtils_1.isShowingStockImages)(this.props.viewStore)) return [3, 2];
                        return [4, this.props.dataStore.fetchQwilrStockImages()];
                    case 1:
                        _a.sent();
                        return [2];
                    case 2:
                        _a.trys.push([2, 8, , 9]);
                        if (!this.props.viewStore.getSearchTerm()) return [3, 4];
                        currentSearchTerm = this.props.viewStore.getSearchTerm();
                        return [4, this.props.dataStore.searchAssets(currentSearchTerm)];
                    case 3:
                        _a.sent();
                        return [2];
                    case 4:
                        if (!((0, ImageLibraryUtils_1.isUnsplashFolder)(this.selectedFolder) && this.props.viewStore.selectedCollection)) return [3, 6];
                        selectedCollectionId = this.props.viewStore.selectedCollection.collectionId;
                        return [4, this.props.dataStore.fetchCollectionImages(selectedCollectionId)];
                    case 5:
                        _a.sent();
                        return [2];
                    case 6: return [4, this.props.dataStore.fetchAssets()];
                    case 7:
                        _a.sent();
                        return [3, 9];
                    case 8:
                        error_1 = _a.sent();
                        this.showErrorMessages();
                        return [3, 9];
                    case 9: return [2];
                }
            });
        }); };
        _this.fetchCollections = function () { return __awaiter(_this, void 0, Promise, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.props.dataStore.fetchCollections()];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.showErrorMessages();
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        _this.searchImages = function (searchTerm) { return __awaiter(_this, void 0, Promise, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.props.dataStore.searchAssets(searchTerm)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        this.showErrorMessages();
                        return [3, 3];
                    case 3:
                        this.props.viewStore.setLoadingOff();
                        return [2];
                }
            });
        }); };
        _this.debounceImageSearch = (0, lodash_1.debounce)(_this.searchImages, 500);
        _this.handleSearchValueChange = function (searchTerm) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.props.viewStore.setLoadingOn();
                        if (this.props.viewStore.getSearchTerm() != searchTerm) {
                            this.props.viewStore.setSearchTerm(searchTerm);
                            this.props.dataStore.emptyAssetList();
                            this.multiSelectStore.clearAllSelections();
                        }
                        return [4, this.debounceImageSearch(searchTerm)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.handleSearchClear = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.handleSearchValueChange("")];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.handleOnUseImage = function (imageId) {
            var image = _this.props.dataStore.getImageById(imageId);
            if (image) {
                _this.props.viewStore.useAsset(image);
            }
        };
        _this.handleOnRenameImage = function (imageId, newName) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!newName)
                            return [2];
                        return [4, this.props.dataStore.renameAsset(imageId, newName)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.handleOnDeleteImage = function (imageId) { return __awaiter(_this, void 0, Promise, function () {
            var foldersViewStore, didDeleteSuccessfully;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        foldersViewStore = this.props.foldersViewStore;
                        if (!!!foldersViewStore) return [3, 2];
                        return [4, this.confirmDelete([imageId])];
                    case 1:
                        didDeleteSuccessfully = _a.sent();
                        if (didDeleteSuccessfully) {
                            this.multiSelectStore.clearAllSelections();
                        }
                        return [3, 4];
                    case 2: return [4, this.props.dataStore.deleteAsset(imageId)];
                    case 3:
                        _a.sent();
                        this.multiSelectStore.clearAllSelections();
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        }); };
        _this.bulkDeleteSelectedImages = function () { return __awaiter(_this, void 0, Promise, function () {
            var didDeleteSuccessfully;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.confirmDelete(this.selectedImageIds)];
                    case 1:
                        didDeleteSuccessfully = _a.sent();
                        if (didDeleteSuccessfully) {
                            this.multiSelectStore.clearAllSelections();
                        }
                        return [2];
                }
            });
        }); };
        _this.confirmDelete = function (idsToDelete) { return __awaiter(_this, void 0, Promise, function () {
            var _a, modal, notifyUser, snapshotOfIds, numToDelete, title, explainer, didDeleteSuccessfully;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, modal = _a.modal, notifyUser = _a.notifyUser;
                        snapshotOfIds = idsToDelete.slice();
                        numToDelete = snapshotOfIds.length;
                        if (numToDelete > 1) {
                            title = "Delete ".concat(numToDelete, " images?");
                            explainer = "Pages using these images won’t be affected, but the images will be removed from your library.";
                        }
                        else {
                            title = "Delete this image?";
                            explainer = "Pages using this image won’t be affected, but this image will be removed from your library.";
                        }
                        return [4, modal.showDeleteModal({
                                title: title,
                                explainer: explainer,
                                confirmLabel: "Delete",
                                confirming: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, this.props.dataStore.bulkDeleteAssets(snapshotOfIds)];
                                            case 1: return [2, _a.sent()];
                                        }
                                    });
                                }); },
                            })];
                    case 1:
                        didDeleteSuccessfully = _b.sent();
                        if (didDeleteSuccessfully) {
                            notifyUser.success("".concat((0, StringManipulater_1.pluralise)(numToDelete, "image"), " deleted"));
                        }
                        return [2, didDeleteSuccessfully];
                }
            });
        }); };
        _this.handleOnMoveImages = function (targetFolder) { return __awaiter(_this, void 0, Promise, function () {
            var dataStore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataStore = this.props.dataStore;
                        return [4, dataStore.moveAssets(this.selectedImageIds, targetFolder)];
                    case 1:
                        _a.sent();
                        this.multiSelectStore.clearAllSelections();
                        return [2];
                }
            });
        }); };
        _this.handleOnSelectCollection = function (collection) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.viewStore.selectCollection(collection)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.selectFolder = function (folderId) {
            var _a = _this.props, dataStore = _a.dataStore, viewStore = _a.viewStore;
            dataStore.selectFolder(folderId);
            viewStore.selectFolder(folderId);
        };
        _this.tryFetchAssetsOrCollections = function (folderId) { return __awaiter(_this, void 0, Promise, function () {
            var _a, dataStore, viewStore, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, dataStore = _a.dataStore, viewStore = _a.viewStore;
                        viewStore.setLoadingOn();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!(0, ImageLibraryUtils_1.isUnsplashFolder)(folderId)) return [3, 3];
                        return [4, dataStore.fetchCollections()];
                    case 2:
                        _b.sent();
                        return [3, 5];
                    case 3: return [4, dataStore.fetchAssets()];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3, 7];
                    case 6:
                        e_1 = _b.sent();
                        this.showErrorMessages();
                        return [3, 7];
                    case 7:
                        viewStore.setLoadingOff();
                        return [2];
                }
            });
        }); };
        _this.showQwilrStockImages = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, dataStore, viewStore;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, dataStore = _a.dataStore, viewStore = _a.viewStore;
                        viewStore.setLoadingOn();
                        viewStore.currentPanelView = Types_2.ImageLibraryViewTypes.StockImages;
                        return [4, dataStore.fetchQwilrStockImages()];
                    case 1:
                        _b.sent();
                        viewStore.setLoadingOff();
                        return [2];
                }
            });
        }); };
        _this.showErrorMessages = function () {
            _this.props.viewStore.currentPanelView = Types_2.ImageLibraryViewTypes.ErrorMessages;
        };
        var notifyUser = props.notifyUser, foldersViewStore = props.foldersViewStore, uploadStore = props.uploadStore;
        _this.duplicateUploadNotifier = new DuplicateUploadNotifier_1.DuplicateUploadNotifier(notifyUser, foldersViewStore, uploadStore);
        _this.assetPanelRef = react_1.default.createRef();
        _this.imageDragLabelRef = react_1.default.createRef();
        _this.init();
        return _this;
    }
    ImageLibrary.prototype.init = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, dataStore, launchOptions;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, dataStore = _a.dataStore, launchOptions = _a.launchOptions;
                        if (!launchOptions.showStockImages) return [3, 2];
                        this.selectFolder(Types_2.ImageLibrarySystemFolder.Unsplash);
                        return [4, this.showQwilrStockImages()];
                    case 1:
                        _c.sent();
                        return [3, 7];
                    case 2:
                        if (!!!launchOptions.startingFolder) return [3, 4];
                        return [4, this.switchFolder(launchOptions.startingFolder)];
                    case 3:
                        _c.sent();
                        return [3, 7];
                    case 4: return [4, this.switchFolder(Types_2.ImageLibrarySystemFolder.Uploads)];
                    case 5:
                        _c.sent();
                        if (!(((_b = dataStore.assets) === null || _b === void 0 ? void 0 : _b.length) === 0)) return [3, 7];
                        return [4, this.switchFolder(Types_2.ImageLibrarySystemFolder.Unsplash)];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7: return [2];
                }
            });
        });
    };
    ImageLibrary.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "asset-library-layout" },
            react_1.default.createElement("div", { className: "asset-library-layout__sidebar" }, this.sidebar),
            react_1.default.createElement("div", { className: "asset-library-layout__main-content" },
                react_1.default.createElement("div", { className: "asset-library-layout__top-actions" }, this.topActions),
                this.areImagesMovable && (react_1.default.createElement(ImageActionTray_1.ImageActionTray, { numSelectedImages: this.multiSelectStore.selectedCount, numLoadedImages: this.numLoadedImages, onDelete: this.bulkDeleteSelectedImages, onSelectAllToggle: this.onSelectAllToggle })),
                react_1.default.createElement("div", { className: "asset-library-layout__asset-panel-wrapper" }, this.assetPanel)),
            this.renderImageDragLabel));
    };
    Object.defineProperty(ImageLibrary.prototype, "sidebar", {
        get: function () {
            var disableDropFolders = new Set();
            if (this.areImagesBeingDragged) {
                disableDropFolders.add(Types_2.ImageLibrarySystemFolder.Unsplash);
                disableDropFolders.add(Types_2.ImageLibrarySystemFolder.RecentlyUsed);
            }
            return (react_1.default.createElement(AssetLibrarySidebar_1.AssetLibrarySidebar, { rootFolder: Types_2.ImageLibrarySystemFolder.Uploads, exploreFoldersList: [Types_2.ImageLibrarySystemFolder.Unsplash, Types_2.ImageLibrarySystemFolder.RecentlyUsed], selectedFolder: this.selectedFolder, assetLogoIcon: react_1.default.createElement(icons_1.Images, { size: icons_1.IconSize.Large }), assetLogoLabel: "Image Library", isFolderSelectionCleared: (0, ImageLibraryUtils_1.isShowingStockImages)(this.props.viewStore), onFolderClick: this.switchFolder, disableDropFolderIds: disableDropFolders, foldersViewStore: this.props.foldersViewStore, onDropOnFolder: this.onDropOnFolder, onDeleteFolder: this.onDeleteFolder }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "topActions", {
        get: function () {
            return (react_1.default.createElement(ImageTopActionBar_1.ImageTopActionBar, { title: this.getTopActionBarTitle(), uploadImage: this.onUploadImage, search: !(0, ImageLibraryUtils_1.isRecentlyUsedFolder)(this.selectedFolder) && !(0, ImageLibraryUtils_1.isShowingStockImages)(this.props.viewStore)
                    ? {
                        label: (0, ImageLibraryUtils_1.isAnUploadsFolder)(this.selectedFolder) ? "Search all uploads" : "Search Unsplash images",
                        placeholder: (0, ImageLibraryUtils_1.isAnUploadsFolder)(this.selectedFolder) ? "Search all uploads" : "Search Unsplash images",
                        onValueChange: this.handleSearchValueChange,
                        value: this.props.viewStore.getSearchTerm(),
                        onClear: this.handleSearchClear,
                    }
                    : undefined }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "assetPanel", {
        get: function () {
            return (react_1.default.createElement("div", { className: "asset-library-layout__asset-panel", ref: this.assetPanelRef },
                react_1.default.createElement(ImageAssetPanel_1.ImageAssetPanel, { isLoading: this.props.viewStore.isLoading, isOutOfNewData: this.props.dataStore.isOutOfNewData, hasFetchingError: (0, ImageLibraryUtils_1.isShowingErrorMessages)(this.props.viewStore), errorMessageProps: this.getErrorMessageComponentProps(), showCollection: (0, ImageLibraryUtils_1.isShowingCollections)(this.props.viewStore), imageCards: this.createImageCards(), collectionCards: this.createCollectionCards(), fetchImages: this.fetchImages, fetchCollections: this.fetchCollections, wrapperElement: this.assetPanelRef })));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "selectedFolder", {
        get: function () {
            return this.props.folderSelectionViewStore.selectedFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "areImagesMovable", {
        get: function () {
            var foldersViewStore = this.props.foldersViewStore;
            return (!!foldersViewStore &&
                (0, ImageLibraryUtils_1.isAnUploadsFolder)(this.selectedFolder));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "renderImageDragLabel", {
        get: function () {
            var numImagesSelected = this.multiSelectStore.selectedCount;
            return (react_1.default.createElement("div", { className: "dashboard__drag-label" },
                react_1.default.createElement(DragLabel_1.default, { divRef: this.imageDragLabelRef, text: (0, StringManipulater_1.pluralise)(numImagesSelected, "image") })));
        },
        enumerable: false,
        configurable: true
    });
    ImageLibrary.prototype.createImageCards = function () {
        var _this = this;
        var _a = this.props, dataStore = _a.dataStore, foldersViewStore = _a.foldersViewStore;
        var draggingEnabled = this.areImagesMovable;
        return dataStore.assets.map(function (image, index) { return (react_1.default.createElement(ImageCard_1.ImageCard, { key: "".concat(_this.selectedFolder, "-").concat(image.id), id: image.id, name: (0, ImageLibraryUtils_1.isUploadedImage)(image) ? image.name : null, url: image.thumbnailUrl, onDelete: !_this.isMultiSelecting ? _this.handleOnDeleteImage : undefined, onUseImage: !_this.isMultiSelecting ? _this.handleOnUseImage : undefined, onRename: !_this.isMultiSelecting ? _this.handleOnRenameImage : undefined, isFormEnabled: (0, ImageLibraryUtils_1.isAnUploadsFolder)(_this.selectedFolder), onDragStart: draggingEnabled ? function (event) { return _this.onImageCardDrag(event, index); } : undefined, onDragEnd: draggingEnabled ? _this.onImageCardDragEnd : undefined, onCheckboxToggle: foldersViewStore ? function (imageId, event) { return _this.onCheckboxToggle(index, event); } : undefined, isCheckboxSelected: _this.multiSelectStore.isSelected(index) })); });
    };
    ImageLibrary.prototype.createCollectionCards = function () {
        var _this = this;
        return this.props.dataStore.collections
            ? this.props.dataStore.collections.map(function (collection) { return (react_1.default.createElement(UnsplashCollection_1.UnsplashCollection, { key: "".concat(_this.selectedFolder, "-").concat(collection.collectionId), collection: collection, onSelectCollection: _this.handleOnSelectCollection, secondaryAction: _this.props.launchOptions.carousel
                    ? {
                        label: "Open in carousel",
                        onClick: function (collection) {
                            _this.props.useAssetCallback(Types_3.MediaSource.UnsplashCollection, collection, Types_3.MetricSource.Collection);
                        },
                    }
                    : null })); })
            : [];
    };
    ImageLibrary.prototype.getErrorMessageComponentProps = function () {
        return (0, ImageFetchingErrorMessageUtils_1.getImageFetchingErrorMessage)(this.selectedFolder, this.showQwilrStockImages);
    };
    Object.defineProperty(ImageLibrary.prototype, "selectedImageIds", {
        get: function () {
            var dataStore = this.props.dataStore;
            return this.multiSelectStore.sortedIndices.map(function (selectedIndex) {
                return dataStore.assets[selectedIndex].id;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "numLoadedImages", {
        get: function () {
            return this.props.dataStore.assets.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibrary.prototype, "isMultiSelecting", {
        get: function () {
            return this.multiSelectStore.selectedCount > 0;
        },
        enumerable: false,
        configurable: true
    });
    ImageLibrary.prototype.onImageCardDrag = function (event, index) {
        event.dataTransfer.effectAllowed = "move";
        var dragData = {
            type: DashboardTypes_1.DragDataType.ResourceCards,
        };
        event.dataTransfer.setData("application/json", JSON.stringify(dragData));
        (0, SetDragImage_1.setDragImage)(event, this.imageDragLabelRef.current);
        this.areImagesBeingDragged = true;
        if (!this.multiSelectStore.isSelected(index)) {
            this.multiSelectStore.setSelection([index]);
        }
    };
    ImageLibrary.prototype.onImageCardDragEnd = function (event) {
        this.areImagesBeingDragged = false;
    };
    ImageLibrary.prototype.onCheckboxToggle = function (index, event) {
        if (event.shiftKey) {
            this.multiSelectStore.rangeSelect(index);
        }
        else {
            this.multiSelectStore.toggleSelection(index);
        }
        if (event.type === "click" && !!event.currentTarget) {
            event.currentTarget.blur();
        }
    };
    ImageLibrary.prototype.onSelectAllToggle = function () {
        if (this.multiSelectStore.selectedCount < this.numLoadedImages) {
            this.multiSelectStore.setSelection((0, lodash_1.range)(this.numLoadedImages));
        }
        else {
            this.multiSelectStore.clearAllSelections();
        }
    };
    ImageLibrary.prototype.switchFolder = function (selectedFolder) {
        return __awaiter(this, void 0, Promise, function () {
            var folderSelectionViewStore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        folderSelectionViewStore = this.props.folderSelectionViewStore;
                        this.multiSelectStore.clearAllSelections();
                        folderSelectionViewStore.setSelectedFolder(selectedFolder);
                        if (this.assetPanelRef.current) {
                            this.assetPanelRef.current.scrollTo(0, 0);
                        }
                        this.selectFolder(selectedFolder);
                        return [4, this.tryFetchAssetsOrCollections(selectedFolder)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ImageLibrary.prototype.onDeleteFolder = function (folderToDelete) {
        return __awaiter(this, void 0, Promise, function () {
            var foldersViewStore, selectedFolderWasDeleted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        foldersViewStore = this.props.foldersViewStore;
                        return [4, foldersViewStore.onDeleteFolder(folderToDelete)];
                    case 1:
                        selectedFolderWasDeleted = _a.sent();
                        if (selectedFolderWasDeleted) {
                            this.switchFolder(Types_2.ImageLibrarySystemFolder.Uploads);
                        }
                        return [2];
                }
            });
        });
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ImageLibrary.prototype, "areImagesBeingDragged", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ImageLibrary.prototype, "selectedFolder", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ImageLibrary.prototype, "areImagesMovable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof react_1.default !== "undefined" && react_1.default.ReactElement) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], ImageLibrary.prototype, "renderImageDragLabel", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageLibrary.prototype, "fetchImages", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageLibrary.prototype, "fetchCollections", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ImageLibrary.prototype, "selectedImageIds", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ImageLibrary.prototype, "numLoadedImages", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ImageLibrary.prototype, "isMultiSelecting", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _b : Object, Number]),
        __metadata("design:returntype", void 0)
    ], ImageLibrary.prototype, "onImageCardDrag", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], ImageLibrary.prototype, "onImageCardDragEnd", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, typeof (_d = typeof kaleidoscope_2.MouseOrKeyboardEvent !== "undefined" && kaleidoscope_2.MouseOrKeyboardEvent) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], ImageLibrary.prototype, "onCheckboxToggle", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ImageLibrary.prototype, "onSelectAllToggle", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ImageLibrary.prototype, "switchFolder", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageLibrary.prototype, "tryFetchAssetsOrCollections", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof kaleidoscope_1.FolderTreeId !== "undefined" && kaleidoscope_1.FolderTreeId) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], ImageLibrary.prototype, "onDeleteFolder", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageLibrary.prototype, "showQwilrStockImages", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageLibrary.prototype, "showErrorMessages", void 0);
    ImageLibrary = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageLibrary);
    return ImageLibrary;
}(react_1.default.Component));
exports.ImageLibrary = ImageLibrary;
